<template>
  <section class="f-61">
    <div class="alive_content">
      <div class="title f-center-title">AI 全面守护，孩子安全快乐全托管</div>
      <div class="content f-select-center">
        <div class="content_item">
          <m-img src="@/v2/auto/assets/image/61/1.jpg" />
          <div class="item_content content_center">
            <div class="content_title f-center-title">
              <div>童声陪伴</div>
              <div>懂你心声</div>
            </div>
            <div class="content_sub_title f-center-sub-title">
              <div>专属声纹识别，用孩子的语言温暖</div>
              <div>对话，知识科普+情感互动双在线</div>
            </div>
          </div>
        </div>
        <!-- 两列 -->
        <div class="content_item_row" v-ia>
          <div class="content_item">
            <m-img src="@/v2/auto/assets/image/61/2.jpg" />
            <div class="item_content">
              <div class="item_title f_item_title">儿童乐园，哄娃神器</div>
              <div class="item_sub_title f_item_sub_title">
                动画/百科/成语边学边玩，还能化身冒险主角，开启沉浸探险旅程
              </div>
            </div>
          </div>
          <div class="content_item">
            <m-img src="@/v2/auto/assets/image/61/3.svg" />
            <div class="item_content">
              <div class="item_title f_item_title">护眼提醒，缓解疲劳</div>
              <div class="item_sub_title f_item_sub_title">
                设置使用时长，到点语音自动提醒，接棒陪玩闲
              </div>
              <div class="item_sub_title f_item_sub_title">
                聊，家长还能随时喊停/加时
              </div>
            </div>
          </div>
        </div>
        <!-- 第三排 -->
        <div class="content_item_row content_item_row_3" v-ia>
          <div class="content_item">
            <m-img src="@/v2/auto/assets/image/61/4.jpg" />
            <div class="item_content">
              <div class="item_title f_item_title">鹰眼哨兵 危险透视</div>
              <div class="item_sub_title f_item_sub_title">
                实时预警行车时站立等风险行为，守护无死角
              </div>
            </div>
          </div>
          <div class="content_item">
            <m-img src="@/v2/auto/assets/image/61/5.jpg" />
            <div class="item_content">
              <div class="item_title f_item_title">后排看护，触手可及</div>
              <div class="item_sub_title f_item_sub_title">
                中控屏一键调取后排屏的影像，同步解锁屏幕操控权，童趣动态尽在掌心
              </div>
            </div>
          </div>
        </div>
        <div class="content_item" v-ia>
          <m-img src="@/v2/auto/assets/image/61/6.jpg" />
          <div class="item_content">
            <div class="item_title f_item_title">离舱守卫，声光护航</div>
            <div class="item_sub_title f_item_sub_title">
              蓝牙距离感应 + 声光双重警报，防遗忘系统全程护航，孩子永不落单
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { replayVideo } from '@/utils'
import replay from '@/components/replay.vue'

export default {
  name: 'Assistant',
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
      activeIndex: 0,
    }
  },
  methods: {
    replayVideo,
  },
}
</script>

<style lang="less" scoped>
// Base styles
.f-61 {
  position: sticky;
  z-index: 79;
  width: 100%;
  background-color: #000;
  overflow: hidden;
}

// Content section
.alive_content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 150px;
  background: #000;
  margin-bottom: 280px;

  .title {
    font-weight: 700;
    display: flex;
    background: radial-gradient(
      131.96% 70.14% at 50% 18.06%,
      #eadaff 0%,
      #ffffff 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    margin-bottom: 63px;
  }

  // Main content area
  .content {
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .content_center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-content: center;
      height: 100%;
      width: 100%;
    }
    .content_item {
      width: 100%;
      position: relative;
      color: white;
      img {
        width: 100%;
        border-radius: 30px;
      }
      .item_content {
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 1;
        .content_title {
          margin-left: 10%;
          font-weight: 600;
          line-height: 1.3;
        }
        .content_sub_title {
          margin-left: 10%;
          margin-top: 20px;
          line-height: 1.5;
        }
        .item_title {
          margin-left: 40px;
          margin-top: 40px;
          margin-bottom: 10px;
        }
        .item_sub_title {
          margin-left: 40px;
          line-height: 1.5;
          color: #ffffffcc;
        }
      }
    }

    .content_item_row {
      display: flex;
      gap: 24px;

      .content_item {
        height: 100%;

        &:first-child {
          width: 40.5%;
          flex-shrink: 0;
        }

        &:last-child {
          width: 57.5%;
          flex-shrink: 0;
        }
      }

      // 第一个 content_item_row 保持原来的宽度比
      .content_item {
        &:first-child {
          width: 57.5%;
        }

        &:last-child {
          width: 40.5%;
        }
      }
    }
    .content_item_row_3 {
      .content_item {
        &:first-child {
          width: 40.5%;
          .item_title {
            margin-left: 10%;
          }
          .item_sub_title {
            margin-left: 10%;
          }
        }

        &:last-child {
          width: 57.5%;
          .item_title {
            margin-left: 8%;
          }
          .item_sub_title {
            margin-left: 8%;
          }
        }
      }
    }
  }
}
</style>
